module.exports = __webpack_public_path__ + "img/03.ea16a700.jpg";